import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useState } from "react";
import EditIcon from "./assets/edit.png";
import {
  accDiv,
  accMul,
  formatAmountWithFixed,
  toFixed,
} from "@/utils/formatBalance";
import { usdcInfo } from "@/constants/tokens";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";

const initList = [
  {
    value: 0,
    label: "No Tips",
  },
  {
    value: 0,
    label: "Custom",
  },
  {
    value: 15,
    label: "15%",
  },
  {
    value: 18,
    label: "18%",
  },
  {
    value: 20,
    label: "20%",
  },
];

const Tip = ({
  orderAmount,
  customTip,
  activeIndex,
  onActiveIndexChange,
  onTipOpen,
}: {
  orderAmount: string;
  customTip: string;
  activeIndex: number;
  onActiveIndexChange: (index: number, tipAmount: string) => void;
  onTipOpen: () => void;
}) => {
  const { currencyUnit, usdToCurrency } = useCurrencyExchange();
  const [list, setList] = useState(initList);

  const handleCustom = () => {
    onTipOpen();
  };

  return (
    <Box
      sx={{
        paddingTop: "12px",
        borderTop: "1px dashed #FFD096",
      }}
    >
      <Text
        sx={{
          color: "#FFF3CC",
          textAlign: "center",
          fontSize: "24px",
          fontWeight: 500,
          fontFamily: "DIN-BoldItalicAlt",
          fontStyle: "italic",
        }}
      >
        Tips
      </Text>
      <Swiper
        defaultValue={activeIndex}
        centeredSlides={true}
        spaceBetween={-10}
        slidesPerView={3}
        onSlideChange={(swiper) => {
          const index = swiper.activeIndex;
          if (customTip && index === 1) {
            console.log(customTip, "customTip");
            onActiveIndexChange(swiper.activeIndex, customTip);
            return;
          }

          const value = list[swiper.activeIndex].value;
          const tipAmount = toFixed(accMul(orderAmount, accDiv(value, 100)), 0);
          onActiveIndexChange(swiper.activeIndex, tipAmount);
        }}
        style={{
          marginTop: "10px",
        }}
      >
        {list.map((item, index) => {
          const isCurrent = activeIndex === index;
          const abs = Math.abs(activeIndex - index);
          const r = activeIndex - index;

          let x = r * 10;

          return (
            <SwiperSlide
              key={index}
              style={{
                width: isCurrent ? "120px" : "120px",
                transform: `scale(${isCurrent ? 1.1 : 1})`,
                height: "80px",
                position: "relative",
                zIndex: isCurrent ? 999 : 999 - abs,
                transition: "all 0.3s",
              }}
            >
              <Flex
                onClick={() => {
                  if (index === 1) {
                    handleCustom();
                  }
                }}
                align={"center"}
                justify={"center"}
                sx={{
                  width: "100%",
                  height: isCurrent ? "50px" : "40px",
                  zIndex: isCurrent ? 999 : 0,
                  transform: `
                   translateY(-50%)
                  `,
                  position: "absolute",
                  top: "50%",
                  left: "0%",
                  transition: "all 0.3s",
                  background: isCurrent ? "#fff" : "#ECC7AA",
                  borderRadius: "100px",
                  fontWeight: "bold",
                }}
              >
                {index === 0 && (
                  <Text
                    sx={{
                      color: "#D8572B",
                      fontSize: isCurrent ? "20px" : "16px",
                    }}
                  >
                    No tips
                  </Text>
                )}

                {index === 1 && (
                  <Flex align={"center"} justify={"center"}>
                    <Text
                      sx={{
                        color: "#D8572B",
                        fontSize: "16px",
                        fontWeight: "blod",
                      }}
                    >
                      {customTip !== "0" ? (
                        <span style={{ fontWeight: "bold" }}>
                          {formatAmountWithFixed(
                            usdToCurrency(customTip),
                            usdcInfo.decimals
                          )}{" "}
                          <span style={{ fontSize: "14px" }}>
                            {currencyUnit}
                          </span>
                        </span>
                      ) : (
                        "Custom"
                      )}
                    </Text>
                    {customTip !== "0" && (
                      <Image
                        src={EditIcon}
                        sx={{
                          width: "12px",
                          marginLeft: "4px",
                        }}
                      ></Image>
                    )}
                  </Flex>
                )}

                {index !== 1 && index !== 0 && (
                  <Flex
                    align={"center"}
                    justify={"center"}
                    sx={{
                      color: "#D8572B",
                      minWidth: "140px",
                    }}
                  >
                    <Text
                      sx={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {formatAmountWithFixed(
                        toFixed(
                          usdToCurrency(
                            accMul(orderAmount, accDiv(item.value, 100))
                          ),
                          0
                        ),
                        usdcInfo.decimals
                      )}{" "}
                      <span style={{ fontSize: "14px" }}>{currencyUnit}</span>
                    </Text>
                    <Text>
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                        }}
                      >
                        ({item.label})
                      </span>{" "}
                    </Text>
                  </Flex>
                )}
              </Flex>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Box>
  );
};

export default Tip;
